
import { Col, Container, Row } from "react-bootstrap";
import Slideshow from '../components/widget/Slideshow'
import classes from "./PortfolioPage.module.css";

function PortfolioPage() {
  const efCollectorLabel = "EF Collector";
  const efCollectorDescription = "Aplicativo móvel personalizado desenvolvido para a empresa Energy Fuels. Permite a captura de informações e imagens sobre perfurações de sondagem através de formulários, diminuindo consideravelmente o tempo de coleta e a ocorrência de falhas.<br/><br/>Possui opções de exportação em formatos compatíveis com outros programas utilizados pela equipe de engenharia, o que torna mais ágil o processo de integração das informações de campo.<br/><br/>* Informações meramente ilustrativas.<br/>";
  const efCollectorLink = "https://www.investidorlibertario.terradata.com.br";
  const efCollectorSlides = [
    { url: "/img/produtos/ef-collector-01.jpeg" },
    { url: "/img/produtos/ef-collector-02.jpeg" },
    { url: "/img/produtos/ef-collector-03.jpeg" },
    { url: "/img/produtos/ef-collector-04.jpeg" },
    { url: "/img/produtos/ef-collector-05.jpeg" }
  ];

  const investidorLibertarioLabel = "INVESTIDOR LIBERTÁRIO";
  const investidorLibertarioDescription = "Sistema desenvolvido para a coleta, análise e visualização de dados de ativos financeiros. Integra diferentes tecnologias em uma solução que realiza a coleta automatizada de dados em fontes online, seguida do processamento, organização e disponibilização das informações. A interface de visualização oferece uma experiência intuitiva, permitindo a visualização e análise dos dados de forma clara, apoiando a tomada de decisões objetivas e seguras no ambiente financeiro.<br/>";
  const investidorLibertarioLink = "https://www.investidorlibertario.terradata.com.br";
  const investidorLibertarioSlides = [
    { url: "/img/produtos/investidor-libertario-01.png" },
    { url: "/img/produtos/investidor-libertario-02.png" },
    { url: "/img/produtos/investidor-libertario-03.png" },
    { url: "/img/produtos/investidor-libertario-04.png" },
  ];

  const relatorioEleitoralLabel = "RELATÓRIO ELEITORAL";
  const relatorioEleitoralDescription = "Produto desenvolvido para candidatos ao poder legislativo ou executivo.<br/> Compila informações disponíveis nos boletins do Tribunal Superior Eleitoral e provê visualização gráfica detalhada sobre a votação, permitindo análises comparativas por seção eleitoral, identificação de padrões de desempenho e suporte à tomada de decisões estratégicas durante e após o processo eleitoral.<br/>";
  const relatorioEleitoralLink = "https://www.terradata.com.br/amostras/relatorio-eleitoral";
  const relatorioEleitoralSlides = [
    { url: "/img/produtos/relatorio-eleitoral-01.png" },
    { url: "/img/produtos/relatorio-eleitoral-02.png" },
    { url: "/img/produtos/relatorio-eleitoral-03.png" },
    { url: "/img/produtos/relatorio-eleitoral-04.png" },
    { url: "/img/produtos/relatorio-eleitoral-05.png" },
    // { url: "/img/produtos/relatorio-eleitoral-06.png" },
    // { url: "/img/produtos/relatorio-eleitoral-07.png" },
    // { url: "/img/produtos/relatorio-eleitoral-08.png" },
    // { url: "/img/produtos/relatorio-eleitoral-09.png" }
  ];

  return (
    <main>
      <section id="portfolio" className={classes.portfolio}>
        <div className="interface">
          <h2 className="titulo">NOSSO <span>PORTFÓLIO.</span></h2>
          <div className={`flex ${classes.flex}`}>
            <Container>
              <Row>
                {/* <Col md={2}></Col> */}
                <Col md={2}>
                  <Slideshow
                    slides={efCollectorSlides}
                    label={efCollectorLabel}/>
                </Col>
                <Col className="text-light"><small dangerouslySetInnerHTML={{ __html:efCollectorDescription}}></small></Col>
              </Row>

              <Row>
                <Col sm className="p-3">
                  <Slideshow
                    slides={relatorioEleitoralSlides}
                    label={relatorioEleitoralLabel}
                    description={relatorioEleitoralDescription}
                    link={relatorioEleitoralLink} />
                  <small className="text-light">* Melhor visualizado em computadores</small>
                </Col>

                <Col sm className="p-3">
                  <Slideshow
                    slides={investidorLibertarioSlides}
                    label={investidorLibertarioLabel}
                    description={investidorLibertarioDescription}
                    link={investidorLibertarioLink} transition='2.5'
                  />
                  <small className="text-light">* Melhor visualizado em computadores</small>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </main>
  );
}

export default PortfolioPage;